import { SEASONS } from '@src/theme/season';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@src/components/Button/Button';
import { useTheme } from '@src/theme/useTheme';

export function SeasonToggle() {
  const { t } = useTranslation();
  const { season, setSeason } = useTheme();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const next = SEASONS[(SEASONS.indexOf(season) + 1) % SEASONS.length];
  async function change() {
    setLoading(true);
    setError(false);
    try {
      await setSeason(next);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }
  return (
    <span>
      <Button
        size="small"
        variant="soft"
        loading={loading}
        onClick={() => void change()}
        testId="season-toggle"
        aria-label={t('theme.seasonSwitch', { season: t(`theme.${next}`) })}
      >
        {t(`theme.${next}`)}
      </Button>
      {error && <span role="alert">{t('theme.seasonError')}</span>}
    </span>
  );
}
